export const getMainColor = ({ theme, appearance }) => {
    switch (appearance) {
        case 'readonly':
            return theme.colors.content.primary;
        case 'disabled':
            return theme.colors.content.disabled;
        default:
            return 'inherit';
    }
};
export const getLabelColor = ({ theme, appearance }) => {
    switch (appearance) {
        case 'readonly':
            return theme.colors.content.primary;
        case 'disabled':
            return theme.colors.content.secondary;
        default:
            return theme.colors.content.active;
    }
};
// color for borders, etc.
export const getAuxillaryColor = ({ theme, appearance }) => {
    switch (appearance) {
        case 'error':
            return theme.colors.signal.error;
        case 'success':
            return theme.colors.signal.success;
        case 'information':
            return theme.colors.signal.neutral;
        default:
            return theme.colors.border.default;
    }
};
// color for character counter
export const getAuxillaryTextColor = ({ theme }) => theme.colors.content.secondary;
// color for notifications
export const getNotificationColor = ({ theme, appearance }) => {
    switch (appearance) {
        case 'error':
            return theme.colors.signal.error;
        case 'success':
            return theme.colors.signal.success;
        default:
            return theme.colors.signal.neutral;
    }
};
